module.exports = __webpack_public_path__ + "static/media/wellbeing-foundations.c65c4b6a.png";